import React, {Component} from 'react';
import { connect } from 'react-redux';
import ProgressBox from './progress-box';
import '../global';
class ProgressBar extends Component{


	render(){

		let passwordBox = (getPasswordSkip() === 'false') ? (<ProgressBox name='user-information' title='Step 1' description='Please update your password.' />) : <ProgressBox none={'none'}/>;
		let committeeBox = (getPasswordSkip() === 'false') ? (<ProgressBox name='committee-section' title='Step 2' description='Leave or cancel your request to join a committee' />) : <ProgressBox name='committee-section' title='Step 1' description='Leave or cancel your request to join a committee' />;
		let infoBox = (getPasswordSkip() === 'false') ? (<ProgressBox name='update-information' title='Step 3' description='Update your profile' />) : <ProgressBox  name='update-information' title='Step 2' description='Update your profile' />;

		return(
			<div className="protocols-step-indicator">
				{passwordBox}
				{committeeBox}
				{infoBox}
			</div>

		);

	}




}


function mapStateToProps( { currentPage, myCommittees, requestedCommittees } ) {
	return {
		currentPage, myCommittees, requestedCommittees
	};
}

export default connect (mapStateToProps)(ProgressBar);